export class BottomSheetModel {
    public text: string;
    public declineOption: string;
    public confirmOption: string;
}